import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { isChatOpen } from "../../../chat";
import { CanvasLayout } from "../../canvas";
import { screenFit } from "../../canvas/function";
import { connect } from "../../redux";
import { getFocusVodItem } from "../function";

const VodStyled = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;

    video {
        flex: 1;
        max-width: 100%;
    }
`;

let prevChannelID;
function VodPlayer({
    item, expand, sidebar, isLeftOpen, shareDocumentPermission, resize
}) {
    if (!item) return null;
    const vodElement  = useRef();
    const [ outerStyle, setOuterStyle ] = useState({ width: 0, height: 0 });
    const [ iframeSize, setIFrameSize ] = useState({ width: 0, height: 0 });

    useEffect(() => {
        getElementSize();

        window.addEventListener("resize", getElementSize);

        return () => {
            window.removeEventListener("resize", getElementSize);
        }
    }, []);

    useEffect(() => {
        getElementSize();
    }, [sidebar, expand, isLeftOpen]);

    const handlerSize = ({width, height}) => {
        setIFrameSize({width, height});
    }

    const getElementSize = () => {
        if (vodElement && vodElement.current) {
            const { width, height } = vodElement.current.getBoundingClientRect();
            setOuterStyle({ width, height: height - 41 });
            let fitStyle = screenFit( width, height, 16, 9, false);

            if (height < fitStyle.height || width < fitStyle.width) {
                fitStyle =  screenFit( width, height, 16, 9, true);
            }

            setIFrameSize(fitStyle);
        }
    }

    
    return (
        <div ref={vodElement} className="vod_player_wrapper">
            <div className="iframe_wrapper" style={{ width: `${iframeSize.width}px`, height: `${iframeSize.height}px` }}>
                <iframe src={`${item.url}`} />

                <CanvasLayout focusItem={{ uuid: item.uuid, index: 1 }} isVod={true} shareDocumentPermission={true} 
                    resize={resize} isWhiteBoard={true} expand={expand} vodStyle={outerStyle}
                    isLeftOpen={isLeftOpen} handlerSize={handlerSize} />   
            </div>
        </div>        
    )
}

function _mapStateToProps(state) {
    const item = getFocusVodItem(state);
    const isChat = isChatOpen(state);
    const {isOpen: isParticipant} = state["features/participant-right"];

    
    return {
        item, sidebar: isChat || isParticipant
    };
}

export default connect(_mapStateToProps)(VodPlayer);